// import LogoIcon from "public/Logo/desktop.svg"
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { extractProperty } from "ui";
import TabPanel from "ui/TabPanel";
import CustomerPazomatTab from "./Tabs/CustomerPazomatTab";
import CustomerServiceTab from "./Tabs/CustomServiceTab";
import TabsHeader from './Tabs/TabsHeader';

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}

type ContactFormSwitchProps = {
  selectedValue: number
  setSelectedValue: Dispatch<SetStateAction<number>>
  data: any
}

function ContactFormSwitch({
  setSelectedValue,
  data
}: ContactFormSwitchProps) {

  const [tabIndex, setTabIndex] = useState(0)

  const contactInfo = extractProperty(data, "contactInfo")
  const button = extractProperty(contactInfo[0], "button")[0]
  const toggleId = extractProperty(contactInfo[0], "toggleId")
  const textLine = extractProperty(contactInfo[0], "textLine")

  const pazomatInfo = extractProperty(data, "pazomatInfo")
  const pazomatToggleId = extractProperty(pazomatInfo[0], "toggleId")
  const pazomatTopText = extractProperty(pazomatInfo[0], "topText")
  const pazomatInnerInfo = extractProperty(pazomatInfo[0], "pazomatInnerInfo")

  useEffect(() => {
    const hash = window?.location?.hash;
    const currentTab = hash === '#pazomat' ? 1 : 0
    setTabIndex(currentTab)
  }, [])

  const handleChange = (e: React.SyntheticEvent, newValue: number) => {
    const newHash = newValue === 0 ? `#${toggleId}` : `#${pazomatToggleId}`;
    history.replaceState(null, '', newHash);
    setTabIndex(newValue)
    setSelectedValue(newValue)
  }
  return (
    <>
      <TabsHeader
        tabIndex={tabIndex}
        handleChange={handleChange}
        setTabIndex={setTabIndex}
        a11yProps={a11yProps}
      />
      <TabPanel value={tabIndex} index={0}>
        <CustomerServiceTab tabIndex={tabIndex} textLine={textLine} button={button} />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <CustomerPazomatTab richTextTop={pazomatTopText} infoBlocks={pazomatInnerInfo} />
      </TabPanel>
    </>
  )
}

export default ContactFormSwitch
